import {
  CONFIDENCE_ATTRIBUTE_NEW,
  CONFIDENCE_ATTRIBUTE_TRUSTED, CONFIDENCE_ATTRIBUTE_WATCH
} from '@/components/platform/funding/ach/constants'
import { RG_9605_ENABLE_ACH } from '@/components/shared/split/split-constants'
import { GET_SELECTED_CUSTOMER_ACCOUNT } from '@/store/get-types'
import { mapGetters } from 'vuex'

const AchMixin = {
  computed: {
    ...mapGetters({
      currentGroupAccount: GET_SELECTED_CUSTOMER_ACCOUNT
    }),
    shouldDisableAch () {
      const confidenceAttribute = this.currentGroupAccount?.confidenceAttribute
      if (!confidenceAttribute) {
        console.error('No confidence attribute found for current group account. ' +
          'Cannot determine if ach disabled dialog should be shown.')
        return false
      }
      switch (confidenceAttribute) {
        case CONFIDENCE_ATTRIBUTE_TRUSTED:
        case CONFIDENCE_ATTRIBUTE_NEW:
          return false
        case CONFIDENCE_ATTRIBUTE_WATCH:
          // Grandfather in older platforms
          if (new Date(this.currentPlatform.createdDate) < new Date('2025-07-06T00:00:00.000Z')) {
            return false
          } else {
            // Split to override and enable ACH
            return !this.$isSplitEnabled(RG_9605_ENABLE_ACH)
          }
        default:
          return true
      }
    }
  }
}

export { AchMixin }
